import { DENTAL_CONSENT_PLANS_LAYOUT } from '../constants/pricingPlans';

const PRICING_URL = 'https://smileconsent.co.uk/dental-consent-plans';

/**
 * Canonical SoftwareApplication JSON-LD — keep offers in sync with pricingPlans.js.
 */
export function getSoftwareApplicationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name: 'Smile Consent - Dental Digital Consent Software',
    applicationCategory: 'DentalPracticeManagement',
    operatingSystem: 'Web',
    url: 'https://smileconsent.co.uk/',
    description:
      'AI dental consent software for UK practices. Generate compliant consent forms, send for digital signature, and keep clear audit trails.',
    publisher: {
      '@type': 'Organization',
      name: 'Smile Consent',
      url: 'https://smileconsent.co.uk',
    },
    offers: DENTAL_CONSENT_PLANS_LAYOUT.map((plan) => ({
      '@type': 'Offer',
      name: `${plan.name} plan`,
      price: plan.price,
      priceCurrency: 'GBP',
      url: PRICING_URL,
      description: `${plan.consents}. ${plan.description}.`,
      availability: 'https://schema.org/InStock',
    })),
  };
}
